module.exports = __webpack_public_path__ + "img/Accountor-31-lowres.491c7f43.jpg";